import { usePlacingPayment } from 'contexts/placingPayment';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormRenderProps } from 'react-final-form';

export const CUSTOM_TIP = 3;

const useViewModel = () => {
  const { t } = useTranslation();
  const { setTotalTipPercent, paymentInfo } = usePlacingPayment();
  const [selectedOption, setSelectedOption] = useState<number | string | null>(null);
  const { tips } = paymentInfo;

  const tipOptions = useMemo(() => {
    const tipsData = tips?.length ? [...tips] : [5, 10, 15];
    const tipResult = tipsData.map((tip) => {
      return { value: tip };
    });
    return tipResult;
  }, [tips]);

  const handleSelectTip = useCallback(
    (value, index, form) => {
      setSelectedOption(index);
      if (selectedOption === CUSTOM_TIP) {
        setSelectedOption(null);
        form.reset();
      }
      if (value !== t('tipCustom')) {
        setTotalTipPercent(value);
      } else {
        setTotalTipPercent(0);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedOption, t],
  );

  const handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    const emptyTip = !value || Number(value) <= 0;
    if (emptyTip) {
      setTotalTipPercent(0);
      return { tip_percentage: true };
    }
    setTotalTipPercent(value);
    return null;
  };

  const handleRemove = (form: FormRenderProps['form']) => {
    form.reset();
    setSelectedOption(null);
    setTotalTipPercent(0);
  };

  return {
    tipOptions,
    handleSelectTip,
    handleOnKeyUp,
    handleRemove,
    selectedOption,
  };
};

export default useViewModel;
